import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import useDebounce from './useDebounce';

export default function useSearch(debounceDelay = 0) {
  const [params, _] = useSearchParams();
  const [search, setSearch] = useState('');

  const debounce = useDebounce(search, debounceDelay);

  useEffect(() => {
    const searchParam = params.get('search');
    setSearch(searchParam || '');
  }, [params]);

  return debounce;
}

export function useSearchUpdate() {
  const [params, setParams] = useSearchParams();
  const [search, setSearch] = useState('');

  const updateSearch = (newSearch) => {
    setParams((prev) => {
      if (newSearch || newSearch === '') prev.set('search', newSearch);
      else prev.delete('search');

      return prev;
    });
  };

  useEffect(() => {
    setSearch(params.get('search'));
  }, [params]);

  return [search, updateSearch];
}
